import { DatePickerInput } from '@mantine/dates';
import { useTranslation } from 'locales';

import { useInvoiceFormContext } from '../InvoiceForm.context';
import type { InvoiceFormSharedProps } from '../InvoiceForm.types';
import { getDefaultDueDate } from '../InvoiceForm.utils';

type DueDateFieldProps = InvoiceFormSharedProps;

export const DueDateField = ({ company }: DueDateFieldProps) => {
  const { currentLang } = useTranslation();
  const form = useInvoiceFormContext();

  const defaultDate = getDefaultDueDate(company);

  return (
    <DatePickerInput
      {...form.getInputProps('due_date')}
      locale={currentLang}
      placeholder={defaultDate.format('L')}
      minDate={new Date()}
    />
  );
};
